<template>
  <div class="diadin">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input style="width: 300px;" clearable :placeholder="$t('menu.cgwdpjdh')+'/'+$t('menu.cgwdpjbm')+'/'+$t('menu.cgwdpjmc')"
          v-model="formInline.orderNumber"></el-input>
      
      </el-form-item>
      <el-form-item>
         <el-select v-model="formInline.orderType" :placeholder="$t('menu.zsddlx')" clearable>
          <el-option :label="$t('menu.Parts')" value="1"></el-option>
          <el-option :label="$t('menu.Vehicle')" value="2"></el-option>

          </el-select>
     
      </el-form-item>
      <el-form-item>
       <el-select v-model="formInline.queryShipmentStatus" :placeholder="$t('menu.fahuozhangt')" clearable>
         <el-option :label="$t('menu.weiwancheng')" value="0"></el-option>
          <el-option :label="$t('menu.yiwancehng')" value="1"></el-option>
          <el-option :label="$t('menu.buxianzhi')" value="-1"></el-option>
        </el-select>
         
      </el-form-item>
     
    
      <el-form-item>
        <el-button type="primary" @click="onSubmit">{{ $t('menu.search') }}</el-button>
      
      </el-form-item>
    </el-form>
   
    <el-table  empty-text=" " :data="mation" style="width: 100%" stripe border highlight-current-row>
      <!-- <el-table-column prop="retailerName"  label="零售商" > </el-table-column> -->
      <el-table-column prop="orderNumber"  :label="$t('menu.cgwdpjdh')" > </el-table-column>
      <el-table-column prop="createTime"  :label="$t('menu.cgwdxdrq')" > </el-table-column>
      <el-table-column prop="orderType"  :label="$t('menu.cgwdlx')">
         <template slot-scope="scope">
         <div v-if="scope.row.orderType=='1'">{{ $t('menu.Parts') }}</div>
           <div v-if="scope.row.orderType=='2'">{{ $t('menu.Vehicle') }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="partNumber"  :label="$t('menu.cgwdpjbm')"> </el-table-column>
        <el-table-column prop="partName"  :label=" $t('menu.cgwdpjmc')" > 
          <template slot-scope="scope">
         <div v-if="iszh=='zh'">{{ scope.row.partName }}</div>
           <div v-else>{{ scope.row.partNameEn }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" :label="$t('menu.cgwddgsl')"> </el-table-column>
      <el-table-column prop="shippedQuantity"  :label="$t('menu.cgwdyfh')"> </el-table-column>
      <el-table-column prop="unshippedQuantity"  :label="$t('menu.cgwdwd')"> </el-table-column>
      
     
     
     
    </el-table>
 <div class="bottompage">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage3"
        :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total,sizes, prev, pager, next"
        :total="totale">
      </el-pagination>
    </div>
    

 
  </div>
</template>
  
  <script>
import { PartOfDealerlist,retailerlist } from "../../api/api";

export default {
  data () {
    return {
      userId: null,
   pageSize:10,
      mation: [], //列表
      cartypelist: [],
      formInline: {
        retailerId: "",
         orderNumber:'',
         orderType:'',
         queryShipmentStatus:''
      },
      currentPage3:1,
      iszh:sessionStorage.getItem('i18n'),
   
    };
  },
  created () {
    // this.listMcSeriesModel()
    this.getList()
    this.getQuerytype()
  },
 
  methods: {
      handleSizeChange (val) {
      this.pageSize = val
      this.getList();
    },
    handleCurrentChange (val) {
      this.currentPage3 = val
      this.getList();
    },
   
    //查询车辆列表
    getList () {
 
      let params = new URLSearchParams();
      let orderNumber=this.formInline.orderNumber
      let orderType=this.formInline.orderType
      let retailerId=this.formInline.retailerId
      let curPage=this.currentPage3
      let pageSize=this.pageSize
      let a =''
      let queryShipmentStatus=this.formInline.queryShipmentStatus
      PartOfDealerlist(params,orderNumber,orderType,retailerId,curPage,pageSize,a,curPage,queryShipmentStatus).then(res => {
        if (res.data.code == 200) {
          this.mation = res.data.rows
          this.totale = res.data.total
        }
      })
    },
   
   
   
 
    //搜索
    onSubmit () {
      this.getList()
    },
  
     //零售商
    getQuerytype () {
 
      const params = new URLSearchParams()
      retailerlist( params, 1,1000).then(r => {
        console.log(r);
        this.cartypelist = r.data.rows;
    
      })
    },
    
  
  },
};
</script>

<style lang="less" scoped>
.bottompage {
  display: flex;
  justify-content: flex-end;
  padding-top: 20px;
}

</style>